import React, { useState, useEffect } from "react";
import axios from "../../axiosConfig"; // Import configured Axios instance
import './ManageBlogs.scss';

import {
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Delete, Archive, TrendingUp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ManageBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {

  const fetchBlogs = async () => {
    try {
      const response = await axios.get("/api/all-blogs");
      setBlogs(response.data.blogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const userRole = localStorage.getItem('userRole');
    if (userRole !== 'ADMIN') {
      navigate('/');
    } else {
      setIsAdmin(true);
      fetchBlogs();
    }

  }, [navigate]);

  if (!isAdmin) {
    return null; // Prevents flashing UI
  }

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        await axios.delete(`/api/blogs/${id}`);
        setBlogs(blogs.filter((blog) => blog._id !== id));
        alert("Blog deleted successfully!");
      } catch (error) {
        console.error("Error deleting blog:", error);
        alert("Error deleting blog. Please try again.");
      }
    }
  };

  const handleArchive = async () => {
    alert("This feature is under development!!");
    // try {
    //   await axios.put(`/api/blogs/archive/${id}`);
    //   alert("Blog archived successfully!");
    // } catch (error) {
    //   console.error("Error archiving blog:", error);
    //   alert("Error archiving blog. Please try again.");
    // }
  };

  const handlePromote = async () => {
    alert("This feature is under development!!");
    // try {
    //   await axios.put(`/api/blogs/promote/${id}`);
    //   alert("Blog promoted to Trending Blogs!");
    // } catch (error) {
    //   console.error("Error promoting blog:", error);
    //   alert("Error promoting blog. Please try again.");
    // }
  };

  if (!isAdmin) {
    return <Typography variant="h5">Checking admin access...</Typography>;
  }

  return (
    <Container className="cards-container">
      <Typography variant="h4" gutterBottom>
        Manage Blogs
      </Typography>
      <Grid container spacing={3}>
        {blogs.map((blog) => (
          <Grid item xs={12} sm={6} md={4} key={blog._id}>
            <Card className="card-item">
              <CardContent>
                <div className="card-intro">
                  <div>
                    <Typography variant="h5">{blog.title}</Typography>
                    <Typography color="textSecondary">
                      Author: {blog.author.name}
                    </Typography>
                  </div>
                  <div >
                    <img className="card-image" src={blog.imageUrl} alt="card poster" />
                  </div>
                </div>

                <Typography variant="body2" dangerouslySetInnerHTML={{ __html: blog.content.substring(0, 100) + '...' }}></Typography>
                <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
                  <Tooltip title="Delete Blog">
                    <IconButton onClick={() => handleDelete(blog._id)} color="error">
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Archive Blog">
                    <IconButton onClick={() => handleArchive()} color="primary">
                      <Archive />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Promote to Trending">
                    <IconButton onClick={() => handlePromote()} color="secondary">
                      <TrendingUp />
                    </IconButton>
                  </Tooltip>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ManageBlogs;
